import React, { useContext } from "react";
import About from "./components/About";
import Contact from "./components/Contact";
import Intro from "./components/Intro";
import ProductList from "./components/ProductList";
import Toggle from "./components/Toggle";
import { ThemeContext } from "./context";
import styled from "styled-components";
import Footer from "./components/Footer";

const Container = styled.div`
  background-color: ${(props) => (props.dark ? "#272727" : "#fff")};
  color: ${(props) => (props.dark ? "#fff" : "#272727")};
`;

const App = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  return (
    <Container dark={darkMode}>
      <Toggle />
      <Intro />
      <About />
      <ProductList />
      <Contact />
      <Footer />
    </Container>
  );
};

export default App;
